export default "__VITE_ASSET__6f40463a__"